import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Modal
} from "reactstrap";
import { Dropdown } from '../../../../assets/components/CustomItems';
import { failedNotification } from '../../../../toolbox/notification-center';
import { jsonEmpty } from '../../../../toolbox/utils';


const useStyles = makeStyles({
    nr: {
        width: '48%',
        marginRight: '2%',
        display: 'inline-block'
    },
    add: {
        width: '48%',
        marginLeft: '2%',
        display: 'inline-block'
    }
})

export default function ExternalModal(props) {

    const classes = useStyles();

    const [init, setInit] = useState(false);

    const [name, setName] = useState("");
    const [contact_person, setContactPerson] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [location, setLocation] = useState("");
    const [phone, setPhone] = useState("");
    const [rol, setRol] = useState("");

    useEffect(() => {
        if (!init && "external" in props && props.external !== null) {
            setContactPerson(props.external.contact_person || "");
            setName(props.external.name);
            setEmail(props.external.email);
            setLocation(props.external.location);
            setPhone(props.external.phone_number);
            setRol(props.external.rol);
        }

    }, [props.external])

    const saveExternal = () => {
        if (props.external !== null) {
            if (contact_person !== "" && name !== "" && email !== "" && location !== "" && phone !== "" && rol !== "") {
                var args = {
                    id: props.external.id,
                    name: name,
                    contact_person: contact_person,
                    email: email,
                    location: location,
                    phone_number: phone,
                    rol: rol
                };
                if (password !== "")
                    args.password = password;
                props.saveExternal(args, () => {
                    props.fetchExternal();
                    props.close();
                }); 
            } else {
                failedNotification("Missende info", "Zorg dat alle velden zijn ingevuld.")
            }
        } else {
            if (contact_person !== "" && name !== "" && email !== "" && password !== "" && location !== "" && phone !== "" && rol !== "") {
                props.saveExternal({
                    name: name,
                    contact_person: contact_person,
                    email: email,
                    password: password,
                    location: location,
                    phone_number: phone,
                    rol: rol
                }, () => {
                    props.fetchExternal();
                    props.close();
                }, (message) => {
                    console.log(message);
                });
            } else {
                failedNotification("Missende info", "Zorg dat alle velden zijn ingevuld.")
            }
        }
    }

    return (
        <Modal
            className="modal-dialog-centered"
            size="sm"
            isOpen={props.open}
            toggle={() => props.close()}
        >
            <div className="modal-body p-0">
                <Card className="bg-secondary shadow border-0">
                    <CardBody className="px-lg-5 py-lg-5">
                        <div className="text-center text-muted mb-4">
                            {props.external !== null ? "Installateur wijzigen" : "Nieuwe installateur"}
                        </div>
                        <Form role="form">
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                    <Input placeholder={"Naam"}
                                        type="text"
                                        id="name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)} />
                                </InputGroup>
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                    <Input placeholder={"Contactpersoon"}
                                        type="text"
                                        id="contact_person"
                                        value={contact_person}
                                        onChange={(e) => setContactPerson(e.target.value)} />
                                </InputGroup>
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                    <Input placeholder={"Email"}
                                        type="text"
                                        id="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)} />
                                </InputGroup>
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                    <Input placeholder={"Wachtwoord"}
                                        type="text"
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)} />
                                </InputGroup>
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                    <Input placeholder={"Stad"}
                                        type="text"
                                        id="location"
                                        value={location}
                                        onChange={(e) => setLocation(e.target.value)} />
                                </InputGroup>
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                    <Input placeholder={"Telefoon"}
                                        type="text"
                                        id="phone"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)} />
                                </InputGroup>
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                    <Input placeholder={"Rol"}
                                        type="text"
                                        id="rol"
                                        value={rol}
                                        onChange={(e) => setRol(e.target.value)} />
                                </InputGroup>
                            </FormGroup>
                            <div className="text-center">
                                <Button
                                    className="my-4"
                                    color="primary"
                                    type="button"
                                    style={{ width: 130 }}
                                    onClick={() => saveExternal()}
                                >
                                    Opslaan
                                </Button>
                                <Button
                                    className="my-4"
                                    type="button"
                                    style={{ width: 130 }}
                                    onClick={() => props.close()}
                                >
                                    Annuleren
                                </Button>
                            </div>
                        </Form>
                    </CardBody>
                </Card>
            </div>
        </Modal>
    )
}